<template lang="pug">
.v-estate.estate(v-if="data" :class="{'estate--state': buttonView}" :id="data?.id")
	h2.estate__title(v-if="data.title") {{ data.title }}
	.estate__filter(v-if="data.fields")
		v-form(:form="{fields: data.fields, remote: data.remote}" @response="handlerResponse" :bxajaxid="data.bxajaxid")
	.estate__items(v-if="data.items && data.items.length")
		.estate__item(v-for="item in data.items" :class="{'open': item.open}")
			.estate__item-head(@click="buttonView ? item.open = !item.open : null")
				.estate__labels
					.labels(v-if="item.labels && item.labels.length")
						.labels__item(v-for="label in item.labels" :class="[label.type ? 'labels__item--' + label.type : '']") {{ label.text }}
							span.labels__item-currency(v-if="label.currency") {{ label.currency }}
				.estate__item-title(v-if="item.title") {{ item.title }}
			.estate__item-subtitle(v-if="item.subtitle") {{ item.subtitle }}
			.estate__slider(v-if="item.media && item.media.length" :key="isTablet")
				v-base-slider(:options="options" theme="dark")
					v-swiper-slide.swiper-slide.estate__slide(v-for="slide in item.media")
						.estate__slide-banner
							img.estate__slide-img(v-if="slide.image && !slide.video" :src="slide.image.small ? slide.image.small : slide.image.src" @click="active = slide")
							v-video-card.estate__slide-video(v-else-if="slide.video" :card="slide")
			.estate__content(v-if="item.content")
				v-show-collapse(:open="item.open")
					.estate__content-body
						v-text-guide(v-if="item.content" :content="item.content")
						v-docs(v-if="item.docs" :props-data="item.docs")
				button.estate__content-btn.btn(v-if="!buttonView" type="button" @click="item.open = !item.open")
					| {{ item.open ? data.closeText : data.openText }}
					v-svg-icon.estate__content-btn-icon(icon="dropdown-small")
				button.btn.estate__content-state(v-if="buttonView" type="button" @click="item.open = !item.open")
					v-svg-icon.estate__content-btn-icon(:icon="item.open ? 'minus' : 'plus'")
	.estate__message(v-else-if="data.notFound") {{ data.notFound }}
	teleport(to="body")
		v-gallery(v-if="this.active" :data="{...active, closeText: data.closeText}" @close="() => this.active = null")
			img.estate__img-zoom(v-if="active.image" :src="active.image.src")
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";
import {SwiperSlide} from 'swiper/vue';
import breakpoints from "../scripts/breakpoints.js";
import VVideoCard from "../components/v-video-card.vue";
import VTextGuide from "../components/v-text-guide.vue";
import VGallery from "../components/v-gallery.vue";

export default {

	components: {
		VGallery,
		VTextGuide,
		VVideoCard,
		'v-swiper-slide': SwiperSlide
	},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		buttonView: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			data: null,
			openModal: null,
			active: null,
			options: {
				freeMode: true,
				watchOverflow: true,
				slidesPerView: 'auto',
				spaceBetween: 15,
				resizeObserver: true,
				loop: false,
				navigation: {
					prevEl: '.swiper-button-prev',
					nextEl: '.swiper-button-next'
				},
				breakpoints: {
					[breakpoints['tablet']]: {
						freeMode: false,
						slidesPerView: 4,
						spaceBetween: 20
					}
				}
			}
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		handlerResponse(res) {
			this.data = res;
		}
	}
}

</script>
